import { types } from "../types/types";

const initialState = {
  catalogModule: {},
  catalogModules: [],
  catalogModulesP: [],
  catalogModulesS: [],

  totalItemsP: 0,
  totalPagesP: 0,
  currentPageP: 0,
  
  totalItemsS: 0,
  totalPagesS: 0,
  currentPageS: 0,
  searchTextState: "",
};
export const catalogModuleReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CATALOGMODULE_SELECT:
      return {
        ...state,
        catalogModule: action.payload,
      };

    case types.CATALOGMODULE_UPDATE:
      if (state.catalogModulesS.length > 0) {
        return {
          ...state,
          catalogModulesS: state.catalogModulesS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
          catalogModulesP: state.catalogModulesP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      } else {
        return {
          ...state,
          catalogModulesP: state.catalogModulesP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      }

    case types.CATALOGMODULE_DELETE:
      if (state.catalogModulesS.length > 0) {
        return {
          ...state,
          catalogModulesS: state.catalogModulesS.filter((usr) => usr.id !== action.payload),
          catalogModulesP: state.catalogModulesP.filter((usr) => usr.id !== action.payload),
          catalogModule: {},
        };
      } else {
        return {
          ...state,
          catalogModulesP: state.catalogModulesP.filter((usr) => usr.id !== action.payload),
          catalogModule: {},
        };
      }

    case types.CATALOGMODULE_START_LOADING:
      
      return {
        ...state,
        catalogModules: action.payload,
      };

    case types.CATALOGMODULE_START_LOADING_PAGINATED:
      return {
        ...state,
        catalogModulesP: action.payload.catalogModulesP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.CATALOGMODULE_START_SEARCH:
      return {
        ...state,
        catalogModulesS: action.payload,
      };

    case types.CATALOGMODULE_START_SEARCH_PAGINATED:
      return {
        ...state,
        catalogModulesS: action.payload.catalogModulesP,
        totalItemsS: action.payload.totalItems,
        totalPagesS: action.payload.totalPages,
        currentPageS: action.payload.currentPage,
      };

    case types.CATALOGMODULE_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        catalogModulesS: [],
      };

    case types.CATALOGMODULE_CLEAN:
      return {
        ...state,
        catalogModule: {},
      };

    case types.CATALOGMODULE_START_REGISTER:
      return {
        ...state,
        catalogModule: action.payload,
      };

    case types.CATALOGMODULE_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.USER_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    default:
      return state;
  }
};
